import React from 'react';
import './Booking.css'
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import PageTitle from '../Components/Common/PageTitle';
import StatCard from '../Components/Common/StatCard';
import BookingsTable from '../Components/Layout/BookingTable';

const Booking = () => {
    return ( 
        <main className='Home'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <PageTitle TitleText='Bookings Management' SubText='Monitor, filter, and manage attendee registrations for the 2024 Electrify Egypt event summit.' HeaderBtnsClass='NoHeaderBtns'/>

                    <section className='StatCards'>
                        <StatCard SCardLabel="TOTAL REGISTRATIONS" SCardValue='1,284' />
                        <StatCard SCardLabel="CONFIRMED" SCardValue='942' />
                        <StatCard SCardLabel="PENDING APPROVAL" SCardValue='312' />
                        <StatCard SCardLabel="CANCELED" SCardValue='30'/>
                    </section>

                    <div className='Activity'>
                        <BookingsTable />
                    </div>

                    
                </div>
            </div>
        </main>
     );
}
 
export default Booking;